import Vue from 'vue'
import Vuex from 'vuex'
// import {getAdminInfo} from '@/api/getData'

Vue.use(Vuex)

const state = {
	adminInfo: {
		avatar: 'default.jpg'
  },
  fullLoading: false,
  token:sessionStorage.getItem('GetInfo'),
  meunShow:true,
  RowId:"",
}

const mutations = {
	saveAdminInfo(state, adminInfo){
		state.adminInfo = adminInfo;
  },
  fullLoadingFun(state, fullLoading) {
    state.fullLoading = fullLoading;
  }
}

const actions = {
	async getAdminData({commit}){
		try{
			// const res = await getAdminInfo()
			if (res.status == 1) {
				commit('saveAdminInfo', res.data);
			}else{
				throw new Error(res)
			}
		}catch(err){
			// console.log('您尚未登陆或者session失效')
		}
	}
}


export default new Vuex.Store({
	state,
	actions,
	mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js